import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../Layout";
import Launcher from "../components/Launcher";
import { WidgetContext } from "../store/widgetContext";
import { useBootstrap } from "./bootstrap/useBootstrap";

const PrivateRoutes = (props) => {
	const context = useContext(WidgetContext);
	const { loading, verified } = useBootstrap(props);

	if (!context.widget || !context.assistant || loading || !verified) {
		return <></>;
	}

	return (
		<Routes>
			<Route path="/home" element={<Layout {...props}><Launcher {...props} /></Layout>} />
			<Route path="*" element={<Navigate to="/private/home" replace />} />
		</Routes>
	);
};

export default PrivateRoutes;
